import { createFileRoute } from '@tanstack/react-router';

import { QuizResultsView } from '#/features/community-hub/components/block-viewers/quiz-results-view';

/**
 * Quiz Results Route
 * Path: /programs/{program}/{module}/{lesson}/results/{attemptId}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/results/$attemptId')({
  component: QuizResultsRoute,
});

function QuizResultsRoute() {
  const { attemptId } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <QuizResultsView key={attemptId} attemptId={attemptId} />;
}
